// CMS Export Dropdown Component
// Export lead data to various case management systems

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { FileSpreadsheet, ChevronDown, Download } from 'lucide-react';

// CMS Export formats (25 total)
export const CMS_FORMATS = [
  // Legal-Specific CMS
  { id: 'filevine', name: 'Filevine', category: 'legal' },
  { id: 'clio', name: 'Clio', category: 'legal' },
  { id: 'mycase', name: 'MyCase', category: 'legal' },
  { id: 'practicepanther', name: 'PracticePanther', category: 'legal' },
  { id: 'smokeball', name: 'Smokeball', category: 'legal' },
  { id: 'casepeer', name: 'CASEpeer', category: 'legal' },
  { id: 'litify', name: 'Litify', category: 'legal' },
  { id: 'needles', name: 'Needles', category: 'legal' },
  { id: 'smartadvocate', name: 'Smart Advocate', category: 'legal' },
  { id: 'cloudlex', name: 'CloudLex', category: 'legal' },
  { id: 'lawmatics', name: 'Lawmatics', category: 'legal' },
  { id: 'rocketmatter', name: 'Rocket Matter', category: 'legal' },
  { id: 'cosmolex', name: 'CosmoLex', category: 'legal' },
  { id: 'abacuslaw', name: 'AbacusLaw', category: 'legal' },
  { id: 'pclaw', name: 'PCLaw', category: 'legal' },
  { id: 'tabs3', name: 'Tabs3', category: 'legal' },
  { id: 'timesolv', name: 'TimeSolv', category: 'legal' },
  { id: 'leaplegal', name: 'LEAP Legal', category: 'legal' },
  // Plaintiff-Specific
  { id: 'trialworks', name: 'TrialWorks', category: 'plaintiff' },
  { id: 'prevail', name: 'Prevail', category: 'plaintiff' },
  { id: 'simplyconvert', name: 'SimplyConvert', category: 'plaintiff' },
  // General CRM
  { id: 'salesforce', name: 'Salesforce', category: 'crm' },
  { id: 'hubspot', name: 'HubSpot', category: 'crm' },
  { id: 'zohocrm', name: 'Zoho CRM', category: 'crm' },
  { id: 'monday', name: 'Monday.com', category: 'crm' },
];

const CMSExportDropdown = ({ onExport }) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          className="w-full border-slate-300 text-slate-700 hover:bg-slate-50"
          size="lg"
          data-testid="export-dropdown-btn"
        >
          <FileSpreadsheet className="w-5 h-5 mr-2" />
          Download for CMS
          <ChevronDown className="w-4 h-4 ml-2" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64 max-h-96 overflow-y-auto">
        <DropdownMenuLabel>Legal Case Management</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {CMS_FORMATS.filter(c => c.category === 'legal').map((cms) => (
          <DropdownMenuItem 
            key={cms.id}
            onClick={() => onExport(cms.id)}
            data-testid={`export-${cms.id}-btn`}
          >
            <Download className="w-4 h-4 mr-2" />
            {cms.name}
          </DropdownMenuItem>
        ))}
        <DropdownMenuSeparator />
        <DropdownMenuLabel>Plaintiff-Specific</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {CMS_FORMATS.filter(c => c.category === 'plaintiff').map((cms) => (
          <DropdownMenuItem 
            key={cms.id}
            onClick={() => onExport(cms.id)}
            data-testid={`export-${cms.id}-btn`}
          >
            <Download className="w-4 h-4 mr-2" />
            {cms.name}
          </DropdownMenuItem>
        ))}
        <DropdownMenuSeparator />
        <DropdownMenuLabel>General CRM</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {CMS_FORMATS.filter(c => c.category === 'crm').map((cms) => (
          <DropdownMenuItem 
            key={cms.id}
            onClick={() => onExport(cms.id)}
            data-testid={`export-${cms.id}-btn`}
          >
            <Download className="w-4 h-4 mr-2" />
            {cms.name}
          </DropdownMenuItem>
        ))}
        <DropdownMenuSeparator />
        <DropdownMenuLabel>Universal Format</DropdownMenuLabel>
        <DropdownMenuItem 
          onClick={() => onExport(null)}
          data-testid="export-universal-btn"
        >
          <FileSpreadsheet className="w-4 h-4 mr-2" />
          All Fields (CSV)
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default CMSExportDropdown;
